export type SegmentConfig = {
  sr: {
    PRIVATE_SEGMENT: string;
    BUSINESS_SEGMENT: string;
  };
  en: {
    PRIVATE_SEGMENT: string;
    BUSINESS_SEGMENT: string;
  };
};

const Segments: SegmentConfig & { [key: string]: { [key: string]: string } } = {
  sr: {
    PRIVATE_SEGMENT: "Privatni-korisnici",
    BUSINESS_SEGMENT: "Biznis-korisnici",
  },
  en: {
    PRIVATE_SEGMENT: "Consumer",
    BUSINESS_SEGMENT: "Business",
  },
};

export default Segments;
